import { readEnterpriseGraph } from "../repository/graph.repository";

export const ReadEnterpriseGraph = async () => {
  try {
    const response = await readEnterpriseGraph();
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
